import { Inject, Injectable } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';


@Injectable()
export class ThemeLoaderService {

  themeFavIcon = 'theme-favicon';

  constructor(
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document) { }

  public setTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  public setFavIcon(url: string): void {
    this.removeNode(this.themeFavIcon);
    this.addNode('image/x-icon', this.themeFavIcon, 'shortcut icon', url);
  }

  public setCssNode(id: string, url: string): Promise<any> {
    const result = new Promise((resolve, reject) => {
      try {
        this.removeNode(id);
        this.addNode('text/css', id, 'stylesheet', url, (element) => {

          const loaded = () => {
            setTimeout(() => resolve(), 250);
            element.removeEventListener('load', loaded);
          }

          element.addEventListener('load', loaded);
        });
      } catch {
        reject();
      }
    });

    return result;
  }

  private removeNode(id: string) : void {
    const linkElement = this.document.head.querySelector("#" + id);
    if ( linkElement ) {
      this.document.head.removeChild( linkElement );
    }
  }

  private addNode(type: string, id: string, rel: string, href: string, callback?: (element: HTMLLinkElement) => void): void {
    const element: HTMLLinkElement = this.document.createElement( "link" );
    element.setAttribute("id", id);
    element.setAttribute("rel", rel);
    element.setAttribute("type", type );
    element.setAttribute("href", href );
    if (callback != null) {
      callback(element);
    }
    this.document.head.appendChild( element );
  }

}
